import React from 'react';

import * as S from './BookingInfo.styles';

const BookingInfo = ({heading, description, customClass}) => {
  return (
    <S.Container className={customClass || ''}>
      {heading && <h3>{heading}</h3>}
      {description && <p>{description}</p>}
    </S.Container>
  );
};

export default BookingInfo;
